import { AxiosResponse } from "axios";
import { Dispatch } from "@reduxjs/toolkit";

import {
  AnalyticsEvents,
  capturePosthogEvent,
} from "../../../common/utils/analytics";
import { RootState } from "../../../redux/store";
import { putApiCall } from "../../../common/constants";
import { setLoading } from "../../../redux/global.slice";
import { setProfileData, setProfileFetched } from "./slices";
import { Module, EndPoint, getApiCall } from "../../../common/constants";
import { apiSuccessCode } from "../../../common/constants/axios.instance";
import { checkInternetAndShowAlert, showAlert } from "../../../common/utils";

export const getMyProfileData =
  (userId: any, isLogin?: boolean | any, callback?: any) =>
  (dispatch: Dispatch<any>) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }
    dispatch(setLoading(true));
    getApiCall(
      Module.manufacturer,
      `${EndPoint.myProfile}?userId=${userId}`,
      (response: AxiosResponse<any>) => {
        const { statusCode, data } = response.data;

        if (statusCode === apiSuccessCode.success) {
          dispatch(setProfileData(data));
          if (isLogin && callback) {
            callback(data.userType, data.permissions, data.hasSubscription);
          }
        }
        dispatch(setLoading(false));
      },
      (error: any) => {
        dispatch(setProfileFetched(true));
        dispatch(setLoading(false));
        showAlert(2, error.message);
      },
    );
  };

export const getMyProfileDataForSupportTicket =
  (userId: string, callback?: (name: string) => void) =>
  (dispatch: Dispatch<any>) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }
    dispatch(setLoading(true));
    getApiCall(
      Module.manufacturer,
      `${EndPoint.myProfile}?userId=${userId}`,
      (response: AxiosResponse<any>) => {
        const { statusCode, data } = response.data;

        if (statusCode === apiSuccessCode.success) {
          dispatch(setProfileData(data));

          const name = `${data.firstName} ${data.lastName}`;
          if (callback) {
            callback(name);
          }
        }
      },
      (error: any) => {
        dispatch(setLoading(false));
        showAlert(2, error.message);
      },
    );
  };

export const updateProfileData =
  (values: any, callback?: () => void) =>
  (dispatch: Dispatch<any>, getState: () => RootState) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }

    dispatch(setLoading(true));

    putApiCall(
      Module.manufacturer + EndPoint.myProfile,
      values,
      (respData: AxiosResponse<any>) => {
        const { data } = respData;
        if (data?.statusCode === apiSuccessCode.ok) {
          const uid = getState().verifyEmail.userId;
          const fieldsChanged = Object.keys(values).filter(
            (k) => k !== "userId" && values[k] !== undefined,
          );
          capturePosthogEvent(AnalyticsEvents.ACCOUNT_SETTINGS_UPDATED, {
            user_id: uid,
            scope: "my_profile",
            fields_changed: fieldsChanged,
          });
          dispatch(getMyProfileData(values.userId));
          showAlert(1, data.message);
          if (callback) callback();
        }

        dispatch(setLoading(false));
      },
      (error: any) => {
        dispatch(setLoading(false));
        showAlert(2, error.message);
      },
    );
  };
